import React from 'react';
import { Card, Statistic, Typography } from 'antd';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  LoadingOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

interface MetricCardProps {
  title: string;
  value: number | string;
  prefix?: React.ReactNode;
  suffix?: string;
  precision?: number;
  valueStyle?: React.CSSProperties;
  trend?: number;
  trendLabel?: string;
  loading?: boolean;
  icon?: React.ReactNode;
  color?: string;
  onClick?: () => void;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  precision = 0,
  valueStyle,
  trend,
  trendLabel,
  loading = false,
  icon,
  color = '#1890ff',
  onClick,
}) => {
  const getTrendIcon = () => {
    if (trend === undefined) return null;
    return trend >= 0 ? (
      <ArrowUpOutlined style={{ color: '#52c41a' }} />
    ) : (
      <ArrowDownOutlined style={{ color: '#f5222d' }} />
    );
  };

  const getTrendColor = () => {
    if (trend === undefined) return undefined;
    return trend >= 0 ? '#52c41a' : '#f5222d';
  };

  return (
    <Card
      bodyStyle={{ padding: '20px 24px' }}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        borderLeft: `4px solid ${color}`,
        transition: 'all 0.3s',
      }}
      hoverable={!!onClick}
      onClick={onClick}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {title}
          </Text>
          {loading ? (
            <div style={{ marginTop: 8 }}>
              <LoadingOutlined style={{ fontSize: 24, color }} />
            </div>
          ) : (
            <Statistic
              value={value}
              prefix={prefix}
              suffix={suffix}
              precision={precision}
              valueStyle={{
                fontSize: 28,
                fontWeight: 600,
                color: '#262626',
                ...valueStyle,
              }}
            />
          )}
          {trend !== undefined && (
            <div style={{ marginTop: 8 }}>
              <Text
                style={{
                  color: getTrendColor(),
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {getTrendIcon()} {Math.abs(trend)}%
              </Text>
              {trendLabel && (
                <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>
                  {trendLabel}
                </Text>
              )}
            </div>
          )}
        </div>
        {icon && (
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 8,
              backgroundColor: `${color}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              color: color,
            }}
          >
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default MetricCard;
